<template>
    <div>
        <div v-if="componentIsReady">
            <div v-if="voidContracts.length > 0">
                <table class="table" style="margin: 0;">
                    <tbody>
                        <tr v-for="(voidContract, index) in voidContracts" :key="index">
                            <td>{{ voidContract.updated_at | moment-date-time }}</td>
                            <td>{{ getDisplayedContractState(voidContract.state) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-else>
                <div class="alert alert-info">Aucun processus annulé</div>
            </div>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script>
    import ComponentLoader from 'components/ComponentLoader'

    export default {
        data() {
            return {
                componentIsReady: false,
                voidContracts: []
            }
        },

        props: {
            contractId: {
                type: Number,
                required: true
            }
        },

        components: {
            ComponentLoader
        },

        mounted() {
            this.getVoidContracts()
        },

        methods: {
            getVoidContracts() {
                this.componentIsReady = false
                
                return this.axios
                    .get(`contracts/${this.contractId}/digital_contracts?void=1`)
                    .then(response => {
                        this.voidContracts = response.data.digital_contracts
                        this.componentIsReady = true
                    })
            },
            getDisplayedContractState(state) {
                if ('refused' == state) {
                    return 'Refusé par le client'
                }
                
                if ('cancelled' == state) {
                    return 'Annulé par Sofrapart'
                }

                return 'Raison inconnue'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature/VoidContracts.vue